import React from 'react';

import { useI18nContext } from '@ecg-marktplaats/js-react-i18n';
import { BasicModalWithFooter, Link, TextLarge, UtilsBlock } from '@hz-design-system/web-ui';

import { getModalButtons, PointItem, Points, TextContentBlock, TopSection } from './components';

import type { ModalProps } from '../types';

import Classes from './BuyerProtectionModal.module.scss';

const BuyerProtectionBuyerModal = ({ isOpen, onClose, buttons }: ModalProps) => {
  const { t } = useI18nContext();
  return (
    <BasicModalWithFooter
      onClose={onClose}
      isOpen={isOpen}
      title=" "
      size="m"
      buttonsAlignmentDesktop="stacked"
      buttons={getModalButtons({ buttons, onClose, t })}
    >
      <TopSection
        assetName="interactions-bp-explanation-buyer"
        title={t('p2pPaymentsUi:dynamicCoverageInfoModal.buyer.mainTitle')}
      />

      <Points title={t('p2pPaymentsUi:dynamicCoverageInfoModal.pointTitle')}>
        <PointItem
          title={t('p2pPaymentsUi:dynamicCoverageInfoModal.buyer.point1.title')}
          description={t('p2pPaymentsUi:dynamicCoverageInfoModal.buyer.point1.description')}
        />
        <PointItem
          title={t('p2pPaymentsUi:dynamicCoverageInfoModal.buyer.point2.title')}
          description={t('p2pPaymentsUi:dynamicCoverageInfoModal.buyer.point2.description')}
        />
        <PointItem
          title={t('p2pPaymentsUi:dynamicCoverageInfoModal.buyer.point3.title')}
          description={t('p2pPaymentsUi:dynamicCoverageInfoModal.buyer.point3.description')}
        />
      </Points>
      <UtilsBlock mb="s">
        <TextContentBlock
          title={t('p2pPaymentsUi:dynamicCoverageInfoModal.buyer.reportSection.title')}
          description={t('p2pPaymentsUi:dynamicCoverageInfoModal.buyer.reportSection.description')}
          descriptionClassName={Classes.pre}
        />
      </UtilsBlock>
      <UtilsBlock mb="s">
        <TextLarge>{t('p2pPaymentsUi:dynamicCoverageInfoModal.helpSection.text')}</TextLarge>
      </UtilsBlock>

      <UtilsBlock mb="s">
        <TextLarge>
          <Link href={t('p2pPaymentsUi:dynamicCoverageInfoModal.helpSection.buyer.linkUrl')} target="_blank">
            {t('p2pPaymentsUi:dynamicCoverageInfoModal.helpSection.linkLabel')}
          </Link>
        </TextLarge>
      </UtilsBlock>
    </BasicModalWithFooter>
  );
};
export default BuyerProtectionBuyerModal;
